<template>
    <div>
        <section class="landscape-tab-products-wrap clearfix pt-5">
            <div class="container">
                <h2 class="text-center mb-5">New collectibles</h2>
                <div class="px-100">

                    <div class="grid-view" :style="{ 'grid-template-columns': `repeat(${perRow}, 1fr)` , margin:'0 -4px' }">
                        <div
                          class="grid-item"
                          v-for="(product,index) in products"
                          :key="index"
                        >
                            <ProductCard
                              :product="product"
                              :isAdmin="isAdmin"
                              :payment_methods="payment_methods"
                              :daily-purchase-limit-amount='dailyPurchaseLimitAmount'
                              :hot-products-disclaimer="hotProductsDisclaimer"
                              :target-from-id="'newProductsCard'"
                            />
                        </div>
                    </div>
                    <div v-if="!isLasPage" class="d-flex justify-content-center m-3">
                        <b-button @click="loadMore" :disabled="apiLoading" variant="outline-primary">
                            <span v-if="!apiLoading">See More</span>
                            <span v-else class="d-flex loading-btn">
                                <span>Loading...</span>
                                <b-spinner small/>
                            </span>
                        </b-button>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ProductCard from '../ProductCard.vue';
import ApiMixin from "../../../../../../../../Modules/Core/Resources/assets/admin/js/mixin/ApiMixin";
import store from "../../store";

export default {
    components: {ProductCard},
    mixins: [ApiMixin],
    props: ['isAdmin', "dailyPurchaseLimitAmount", "hotProductsDisclaimer", "payment_methods"],
    data() {
        return {
            currentPage: 1,
            lastPage: 1,
            products: [],
            apiLoading: false,
            windowWidth: window.innerWidth,
        }
    },
    watch: {
        // Watch for changes to window width and update the property
        windowWidth(newWidth) {
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
    },
    mounted() {
        window.addEventListener('resize', this.updateWindowWidth);
        this.getProduct()
    },
    destroyed() {
        window.removeEventListener('resize', this.updateWindowWidth);
    },
    computed: {
        isLasPage() {
            return this.lastPage === this.currentPage
        },
        perRow() {
            if (this.windowWidth >= 1250) {
                return 5;
            } else if (this.windowWidth >= 920) {
                return 3;
            } else if (this.windowWidth >= 768) {
                return 2;
            } else {
                return 1;
            }
        },
    },
    methods: {
        getProduct(perPage = Math.max(5, this.perRow)) {
            this.apiLoading = true;

            $.ajax({
                method: "GET",
                url: route("products_list", {
                    sort: 'latest',
                    per_page: perPage,
                    page: this.currentPage
                }),

            })
                .then((res) => {
                    this.currentPage = res.data.current_page
                    this.lastPage = res.data.last_page
                    res.data.data.forEach(item => {
                        this.products.push(item)
                    })
                })
                .catch((xhr) => {
                    this.$errorNotify(xhr.responseJSON.message)
                })
                .always(() => {
                    this.apiLoading = false;
                });
        },
        loadMore() {
            this.currentPage++
            this.getProduct()
        },
        updateWindowWidth() {
            // Update window width and trigger watcher
            this.windowWidth = window.innerWidth;
        },
    }
};
</script>

<style lang="scss">
.grid-view {
    display: grid;
    grid-gap: 20px;
}

.grid-view .grid-item {
    display: flex;
}

.grid-view .grid-item .product-card {
    width: 100%;
    margin: 0;
}

.loading-btn {
    align-items: center;
    gap: 10px;
}


@media screen and (min-width: 1920px) {
    .grid-view {
        grid-template-columns: repeat(6, 1fr);
    }
}

@media screen and (max-width: 1024px) {
    .grid-view {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (max-width: 590px) {
    .grid-view {
        grid-template-columns: repeat(1, 1fr);
    }
}

</style>
